import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Auth } from '@core/services';

export const authGuard: CanActivateFn = () => {
  const authService = inject(Auth);
  const router = inject(Router);

  const token = authService.token;

  if (!token) {
    router.navigate(['/login']);
    localStorage.clear();
    return false;
  }

  return true;
};
